export const ADD_ATTRIBUTS = 'ADD_ATTRIBUTS'
export const ADD_ATTRIBUT = 'ADD_ATTRIBUT'
